import api from './api';
import type { Order, CreateOrderPayload, CreateOrderResponse } from '../types';

interface PaymentLinkResponse {
  url: string;
}

interface ShortLinkResponse {
  short_url: string;
}

const orderService = {
  getOrders: async (comercioKey: string): Promise<Order[]> => {
    const response = await api.get<Order[]>(`/comercios/${comercioKey}/pedidos`);
    return response.data;
  },

  getOrderById: async (comercioKey: string, orderId: number): Promise<Order> => {
    const response = await api.get<Order>(`/comercios/${comercioKey}/pedidos/${orderId}`);
    return response.data;
  },

  createOrder: async (comercioKey: string, orderData: CreateOrderPayload): Promise<CreateOrderResponse> => {
    const response = await api.post<CreateOrderResponse>(`/comercios/${comercioKey}/pedidos`, orderData);
    return response.data;
  },

  // Long Stripe Checkout URL (kept for backwards compatibility)
  createPaymentLink: async (comercioKey: string, orderId: number): Promise<PaymentLinkResponse> => {
    const response = await api.post<PaymentLinkResponse>(`/comercios/${comercioKey}/pedidos/${orderId}/crear-pago`);
    return response.data;
  },

  // Short, opaque URL that hides the order id
  createShortPaymentLink: async (comercioKey: string, orderId: number): Promise<ShortLinkResponse> => {
    const response = await api.post<ShortLinkResponse>(`/comercios/${comercioKey}/pedidos/${orderId}/short-link`);
    return response.data;
  },

  verifyPayment: async (comercioKey: string, orderId: number, sessionId: string): Promise<void> => {
    await api.post(`/comercios/${comercioKey}/pedidos/${orderId}/verificar-pago`, { sessionId });
  },
};

export default orderService;
